import React from 'react';

import { IIconProps } from 'assets/icons/IconProps';

export const SingleUnitIcon = ({
  width = 22,
  height = 10,
  stroke = '#52575C',
  strokeWidth = 2,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 22 10"
  >
    <path
      d="M5 5H5.01M3 1H19C20.1046 1 21 1.89543 21 3V7C21 8.10457 20.1046 9 19 9H3C1.89543 9 1 8.10457 1 7V3C1 1.89543 1.89543 1 3 1Z"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
